module.exports = __webpack_public_path__ + "media/images/riders/small/PHIL_ATWILL-343b21887cbe71f4db80695fc0594a06.png";